module.exports = __webpack_public_path__ + "img/taekwondo1.16221271.jpg";